// removed by extract-text-webpack-plugin
module.exports = {"main":"location-status-icon-main--j-6Jc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LocationStatusIcon/location-status-icon.scss
// module id = JNc/
// module chunks = 4